// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SVM9uoPN64K_pwXh160d {
  background-color: #F8FAFF;
  min-height: calc(100vh - 75px);
  padding: 48px 16px 16px 16px;
}

.O6uVy9ltT56AaEK9E4xL {
  max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]};
  margin: auto auto 72px;
  position: relative;
}

.wrvpDBLLxNCMJOTJAH6Q {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.uNZstZOz1jExSJHFenU4 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.KMf2e4d8RZ5RKTvJLCKT, .SIhVTw5QBYk6oI6Okm1L {
  width: 100%;
  margin: auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.G_5TalkzuRtBxaUeSxr0 {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-success"]};
}

.mRiGrd9U1j1dlHtbnUwI {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-error"]};
}

.bk064o4aaoSkTdMJZQCP {
  width: 70%;
  height: 50vh;
  margin: auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.ygJwqF3Ivlt8SxhL9E4f, .G_5TalkzuRtBxaUeSxr0, .mRiGrd9U1j1dlHtbnUwI {
  font-size: 48px;
  margin-bottom: 24px;
}

.pVw1L7gbJxGpkHD4pLK6 {
  margin-top: 0;
  margin-bottom: 4px;
  font-size: 24px;
}

.yQA7tvoE7_UK2QHzCDqH {
  text-align: center;
}

.mseSkZXaEyLNSvTSdk9N {
  background-color: #F8FAFF;

  width: 100%;
  min-height: calc(100vh - 75px);

  display: flex;
  justify-content: center;
}

.hh3KMI2cYiaHiIX9EoFL {
  margin-top: 48px;

  background-color: white;
  border-radius: 5px;

  padding: 24px;
  width: 550px;
  height: max-content;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.e80OIuuk4oNJG80bb6tJ {
  margin: auto auto 16px;
  background-color: #FAEDED;

  width: 80px;
  height: 80px;
  border-radius: 80px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.KDwtyuj8HEZzMQsFpg8g {
  color: #E30101;
  font-size: 30px !important;
}

.pVw1L7gbJxGpkHD4pLK6 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
}

.yQA7tvoE7_UK2QHzCDqH {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  letter-spacing: 0.005em;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 0;
}

.cFDq5UwHq0UZVq9ciZgB {
  width: 100%;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  .SVM9uoPN64K_pwXh160d {
    padding: 100px 16px 16px 16px;
    height: 100vh;
    box-sizing: border-box;

    text-align: center;
  }

  .bk064o4aaoSkTdMJZQCP {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Confirmation/ConfirmationRedirection/ConfirmationRedirection.module.css"],"names":[],"mappings":"AAMA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uDAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mDAAoB;AACtB;;AAEA;EACE,mDAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,mDAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;;EAEzB,WAAW;EACX,8BAA8B;;EAE9B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;;EAEhB,uBAAuB;EACvB,kBAAkB;;EAElB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;;EAEtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;;EAEzB,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;;IAEtB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle, color-success, color-error from colors;\n\n.container {\n  background-color: #F8FAFF;\n  min-height: calc(100vh - 75px);\n  padding: 48px 16px 16px 16px;\n}\n\n.content {\n  max-width: desktop;\n  margin: auto auto 72px;\n  position: relative;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.buttonGroup {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 24px;\n}\n\n.success, .error {\n  width: 100%;\n  margin: auto;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.check {\n  color: color-success;\n}\n\n.errorIcon {\n  color: color-error;\n}\n\n.waiting {\n  width: 70%;\n  height: 50vh;\n  margin: auto;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  color: color-purple;\n}\n\n.loading, .check, .errorIcon {\n  font-size: 48px;\n  margin-bottom: 24px;\n}\n\n.title {\n  margin-top: 0;\n  margin-bottom: 4px;\n  font-size: 24px;\n}\n\n.description {\n  text-align: center;\n}\n\n.background {\n  background-color: #F8FAFF;\n\n  width: 100%;\n  min-height: calc(100vh - 75px);\n\n  display: flex;\n  justify-content: center;\n}\n\n.modal {\n  margin-top: 48px;\n\n  background-color: white;\n  border-radius: 5px;\n\n  padding: 24px;\n  width: 550px;\n  height: max-content;\n  box-sizing: border-box;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.illustration {\n  margin: auto auto 16px;\n  background-color: #FAEDED;\n\n  width: 80px;\n  height: 80px;\n  border-radius: 80px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  color: #E30101;\n  font-size: 30px !important;\n}\n\n.title {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  text-align: center;\n}\n\n.description {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: 0.005em;\n  color: rgba(0, 0, 0, 0.55);\n  margin-top: 0;\n}\n\n.button {\n  width: 100%;\n}\n\n@media screen and (max-width: tablet) {\n  .container {\n    padding: 100px 16px 16px 16px;\n    height: 100vh;\n    box-sizing: border-box;\n\n    text-align: center;\n  }\n\n  .waiting {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"color-success": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-success"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-error"]}`,
	"container": `SVM9uoPN64K_pwXh160d`,
	"content": `O6uVy9ltT56AaEK9E4xL`,
	"row": `wrvpDBLLxNCMJOTJAH6Q`,
	"buttonGroup": `uNZstZOz1jExSJHFenU4`,
	"success": `KMf2e4d8RZ5RKTvJLCKT`,
	"error": `SIhVTw5QBYk6oI6Okm1L`,
	"check": `G_5TalkzuRtBxaUeSxr0`,
	"errorIcon": `mRiGrd9U1j1dlHtbnUwI`,
	"waiting": `bk064o4aaoSkTdMJZQCP`,
	"loading": `ygJwqF3Ivlt8SxhL9E4f`,
	"title": `pVw1L7gbJxGpkHD4pLK6`,
	"description": `yQA7tvoE7_UK2QHzCDqH`,
	"background": `mseSkZXaEyLNSvTSdk9N`,
	"modal": `hh3KMI2cYiaHiIX9EoFL`,
	"illustration": `e80OIuuk4oNJG80bb6tJ`,
	"icon": `KDwtyuj8HEZzMQsFpg8g`,
	"button": `cFDq5UwHq0UZVq9ciZgB`
};
export default ___CSS_LOADER_EXPORT___;
